module.exports = __webpack_public_path__ + "70954f910e80e8544ad3bdfcf390ee6e.svg";